<template>
  <div class="app-container" :class="{ 'dark-mode': darkMode, 'sidebar-collapsed': sidebarCollapsed }">
    <!-- 侧边栏 -->
    <aside class="sidebar">
      <div class="logo-area">
        <img src="@/assets/logo/logo.png" class="logo-img" alt="若梦壁纸" />
        <div class="logo-text-group">
          <span class="logo-text">若梦Dreamy</span>
          <span class="logo-sub">Management Console</span>
        </div>
      </div>
      <div class="menu-section">
        <div class="menu-group">
          <div class="menu-label">概览</div>
          <div class="menu-list">
            <el-tooltip content="仪表盘" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/dashboard" class="menu-item" :class="{ active: activeMenu === '/dashboard' }"
                v-permission="['wallpaper:view', 'submission:view', 'user:view', 'setting:view', 'manager:view']">
                <i class="el-icon-s-data menu-icon"></i>
                <span>仪表盘</span>
              </router-link>
            </el-tooltip>
          </div>
        </div>

        <div class="menu-group">
          <div class="menu-label">内容管理</div>
          <div class="menu-list">
            <el-tooltip content="壁纸管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/wallpaper" class="menu-item" :class="{ active: activeMenu === '/wallpaper' }"
                v-permission="'wallpaper:view'">
                <i class="el-icon-picture-outline menu-icon"></i>
                <span>壁纸管理</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="分类维护" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/category" class="menu-item" :class="{ active: activeMenu === '/category' }"
                v-permission="'category:view'">
                <i class="el-icon-folder-opened menu-icon"></i>
                <span>分类维护</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="标签维护" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/tag" class="menu-item" :class="{ active: activeMenu === '/tag' }"
                v-permission="'tag:view'">
                <i class="el-icon-price-tag menu-icon"></i>
                <span>标签维护</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="盲盒文案" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/quote" class="menu-item" :class="{ active: activeMenu === '/quote' }"
                v-permission="'quote:view'">
                <i class="el-icon-chat-dot-round menu-icon"></i>
                <span>盲盒文案</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="广告管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/advert" class="menu-item" :class="{ active: activeMenu === '/advert' }"
                v-permission="['wallpaper:view', 'announcement:view']">
                <i class="el-icon-present menu-icon"></i>
                <span>广告管理</span>
              </router-link>
            </el-tooltip>
          </div>
        </div>

        <div class="menu-group">
          <div class="menu-label">运营管理</div>
          <div class="menu-list">
            <el-tooltip content="投稿审核" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/review" class="menu-item" :class="{ active: activeMenu === '/review' }"
                v-permission="'submission:view'">
                <i class="el-icon-document-checked menu-icon"></i>
                <span>投稿审核</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="用户管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/users" class="menu-item" :class="{ active: activeMenu === '/users' }"
                v-permission="'user:view'">
                <i class="el-icon-user menu-icon"></i>
                <span>用户管理</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="意见反馈" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/feedback" class="menu-item" :class="{ active: activeMenu === '/feedback' }"
                v-permission="'feedback:view'">
                <i class="el-icon-chat-line-round menu-icon"></i>
                <span>意见反馈</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="举报管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/report" class="menu-item" :class="{ active: activeMenu === '/report' }"
                v-permission="'report:view'">
                <i class="el-icon-warning-outline menu-icon"></i>
                <span>举报管理</span>
              </router-link>
            </el-tooltip>
          </div>
        </div>

        <div class="menu-group">
          <div class="menu-label">系统管理</div>
          <div class="menu-list">
            <el-tooltip content="公告管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/announcement" class="menu-item" :class="{ active: activeMenu === '/announcement' }"
                v-permission="'announcement:view'">
                <i class="el-icon-position menu-icon"></i>
                <span>公告管理</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="操作日志" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/operationLog" class="menu-item" :class="{ active: activeMenu === '/operationLog' }"
                v-permission="'log:view'">
                <i class="el-icon-tickets menu-icon"></i>
                <span>操作日志</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="权限管理" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/settings" class="menu-item" :class="{ active: activeMenu === '/settings' }"
                v-permission="'manager:view'">
                <i class="el-icon-set-up menu-icon"></i>
                <span>权限管理</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="系统设置" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/system" class="menu-item" :class="{ active: activeMenu === '/system' }"
                v-permission="'setting:view'">
                <i class="el-icon-setting menu-icon"></i>
                <span>系统设置</span>
              </router-link>
            </el-tooltip>
            <el-tooltip content="帮助中心" placement="right" :disabled="!sidebarCollapsed" effect="dark">
              <router-link to="/help" class="menu-item" :class="{ active: activeMenu === '/help' }">
                <i class="el-icon-service menu-icon"></i>
                <span>帮助中心</span>
              </router-link>
            </el-tooltip>
          </div>
        </div>
      </div>
      <!-- <div class="sidebar-footer">
        <span class="version-text">v1.0.0</span>
      </div> -->
    </aside>

    <!-- 右侧区域 -->
    <div class="right-area">
      <!-- 顶部导航栏 -->
      <header class="top-header">
        <div class="header-left">
          <el-tooltip :content="sidebarCollapsed ? '展开菜单' : '收起菜单'" placement="bottom" effect="dark">
            <div class="sidebar-toggle-btn" @click="sidebarCollapsed = !sidebarCollapsed">
              <i :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            </div>
          </el-tooltip>
          <span class="header-breadcrumb">{{ pageTitle }}</span>
        </div>
        <div class="header-right">
          <!-- 深色模式切换 -->
          <el-tooltip :content="darkMode ? '切换浅色模式' : '切换深色模式'" placement="bottom" effect="dark">
            <div class="dark-toggle" @click="toggleDarkMode">
              <i :class="darkMode ? 'el-icon-sunny' : 'el-icon-moon'" />
            </div>
          </el-tooltip>
          <!-- 帮助 -->
          <el-tooltip content="帮助" placement="bottom" effect="dark">
            <div class="help-entry" @click="$router.push('/help')">
              <i class="el-icon-help" />
            </div>
          </el-tooltip>
          <!-- 官网入口 -->
          <el-tooltip content="访问官网" placement="bottom" effect="dark">
            <div class="website-entry" @click="openWebsite">
              <i class="el-icon-link" />
            </div>
          </el-tooltip>
          <!-- 通知铃铛 -->
          <div class="header-notify">
            <el-popover ref="notifyPopover" placement="bottom-end" width="360" trigger="click" :visible-arrow="false"
              popper-class="notify-popover" @show="loadNotifications">
              <div slot="reference" class="notify-trigger">
                <el-badge :value="unreadCount" :max="99" :hidden="unreadCount === 0" class="notify-badge">
                  <i class="el-icon-bell"></i>
                </el-badge>
              </div>
              <div class="notify-panel">
                <div class="notify-header">
                  <span class="notify-title">消息通知</span>
                  <div class="notify-header-right">
                    <span v-if="unreadCount > 0" class="notify-read-all" @click="handleMarkAllRead">全部已读</span>
                    <span class="notify-view-all" @click="goNotification">查看全部</span>
                  </div>
                </div>
                <div class="notify-list" v-if="notifications.length > 0">
                  <div v-for="item in notifications" :key="item.id" class="notify-item"
                    :class="{ unread: !item.isRead }" @click="handleNotifyClick(item)">
                    <div class="notify-item-icon" :class="'icon-' + item.type">
                      <i v-if="item.type === 'submission'" class="el-icon-document-checked"></i>
                      <i v-else-if="item.type === 'feedback'" class="el-icon-chat-line-round"></i>
                      <i v-else-if="item.type === 'user'" class="el-icon-user"></i>
                      <i v-else-if="item.type === 'report'" class="el-icon-warning-outline"></i>
                    </div>
                    <div class="notify-item-body">
                      <div class="notify-item-title">
                        <span class="notify-dot" v-if="!item.isRead"></span>
                        {{ item.title }}
                      </div>
                      <div class="notify-item-content">{{ item.content }}</div>
                      <div class="notify-item-time">{{ item.createTime }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="notify-empty">
                  <i class="el-icon-bell"></i>
                  <span>暂无消息</span>
                </div>
              </div>
            </el-popover>
          </div>
          <!-- 用户下拉 -->
          <el-dropdown trigger="click" @command="handleUserCommand">
            <span class="user-info">
              <el-avatar :size="32" icon="el-icon-user-solid" class="user-avatar" />
              <span class="user-name">{{ currentUserName }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user" command="profile">个人信息</el-dropdown-item>
              <el-dropdown-item icon="el-icon-key" command="password">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>
      <!-- 主内容区 -->
      <main class="main-content">
        <router-view />
      </main>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="420px" :close-on-click-modal="false"
      custom-class="password-dialog">
      <div class="pwd-tip">
        <i class="el-icon-warning-outline"></i>
        为保障账号安全，请定期更新登录密码
      </div>
      <el-form :model="passwordForm" label-position="top" size="small">
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password
            prefix-icon="el-icon-lock" />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="至少6位" show-password
            prefix-icon="el-icon-key" />
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password
            prefix-icon="el-icon-key" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="handleChangePassword" :loading="passwordSaving">确定修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getNotifications, markNotificationRead, markAllNotificationsRead, changeAdminPassword } from '@/api/index'

export default {
  name: 'Layout',
  data() {
    return {
      darkMode: localStorage.getItem('admin-dark-mode') === '1',
      sidebarCollapsed: localStorage.getItem('admin-sidebar-collapsed') === '1',
      notifications: [],
      totalUnreadCount: 0,
      notificationInterval: null,
      // 修改密码弹窗
      passwordDialogVisible: false,
      passwordSaving: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    pageTitle() {
      const map = {
        '/dashboard': '仪表盘',
        '/wallpaper': '壁纸管理',
        '/review': '投稿审核',
        '/users': '用户管理',
        '/advert': '广告管理',
        '/category': '分类维护',
        '/categories': '分类维护',
        '/tag': '标签维护',
        '/quote': '盲盒文案',
        '/settings': '设置管理',
        '/operationLog': '操作日志',
        '/announcement': '公告管理',
        '/feedback': '意见反馈',
        '/report': '举报管理',
        '/help': '帮助中心',
        '/profile': '个人信息'
      }
      return map[this.$route.path] || '管理后台'
    },
    unreadCount() {
      return this.totalUnreadCount
    },
    profileRoles() {
      const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
      const roles = user.roles || []
      const roleNameMap = {
        super_admin: '超级管理员',
        editor: '内容编辑',
        reviewer: '审核员',
        operator: '运营',
        viewer: '只读用户'
      }
      return roles.map(r => roleNameMap[r] || r)
    },
    currentUserName() {
      const user = JSON.parse(localStorage.getItem('admin_user') || '{}')
      return user.name || user.username || '管理员'
    }
  },
  mounted() {
    this.loadNotifications()
    // 每30秒轮询一次新通知
    this.notificationInterval = setInterval(() => {
      this.loadNotifications()
    }, 30000)
  },
  watch: {
    sidebarCollapsed(val) {
      localStorage.setItem('admin-sidebar-collapsed', val ? '1' : '0')
    }
  },
  beforeDestroy() {
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval)
    }
  },
  methods: {
    /**
     * 打开官网
     */
    openWebsite() {
      window.open('https://ruomeng.icu/', '_blank')
    },
    toggleDarkMode() {
      this.darkMode = !this.darkMode
      localStorage.setItem('admin-dark-mode', this.darkMode ? '1' : '0')
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('token')
          this.$message.success('已退出登录')
          this.$router.push('/login')
        }).catch(() => { })
      } else if (command === 'profile') {
        this.$router.push('/profile').catch(() => {})
      } else if (command === 'password') {
        this.openPasswordDialog()
      }
    },
    openPasswordDialog() {
      this.passwordForm.oldPassword = ''
      this.passwordForm.newPassword = ''
      this.passwordForm.confirmPassword = ''
      this.passwordDialogVisible = true
    },
    async handleChangePassword() {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm
      if (!oldPassword) {
        this.$message.warning('请输入原密码')
        return
      }
      if (!newPassword) {
        this.$message.warning('请输入新密码')
        return
      }
      if (newPassword.length < 6) {
        this.$message.warning('新密码至少6位')
        return
      }
      if (newPassword !== confirmPassword) {
        this.$message.warning('两次输入的新密码不一致')
        return
      }

      this.passwordSaving = true
      try {
        const res = await changeAdminPassword({ oldPassword, newPassword })
        if (res.code === 200) {
          this.$message.success('密码修改成功')
          this.passwordDialogVisible = false
        } else {
          this.$message.error(res.msg || '密码修改失败')
        }
      } catch (e) {
        this.$message.error('密码修改失败')
      } finally {
        this.passwordSaving = false
      }
    },
    async loadNotifications() {
      try {
        const res = await getNotifications()
        if (res.code === 200) {
          this.notifications = res.data.list || []
          this.totalUnreadCount = res.data.unreadCount || 0
        }
      } catch (e) {
        // 静默失败
      }
    },
    async handleNotifyClick(item) {
      try {
        await markNotificationRead(item.id)
        item.isRead = true
        if (this.totalUnreadCount > 0) this.totalUnreadCount--
      } catch (e) { /* ignore */ }
      // 根据通知类型跳转对应页面
      if (item.type === 'submission') {
        if (this.$route.path !== '/review') {
          this.$router.push('/review')
        }
      } else if (item.type === 'feedback') {
        if (this.$route.path !== '/feedback') {
          this.$router.push('/feedback')
        }
      } else if (item.type === 'user') {
        if (this.$route.path !== '/users') {
          this.$router.push('/users')
        }
      } else if (item.type === 'report') {
        if (this.$route.path !== '/report') {
          this.$router.push('/report')
        }
      }
    },
    async handleMarkAllRead() {
      try {
        await markAllNotificationsRead()
        this.notifications.forEach(n => { n.isRead = true })
        this.totalUnreadCount = 0
      } catch (e) { /* ignore */ }
    },
    goNotification() {
      const popover = this.$refs.notifyPopover
      if (popover) popover.doClose()
      if (this.$route.path !== '/notification') {
        this.$router.push('/notification')
      }
    }
  }
}
</script>

<style>
body {
  background: #F0F2F5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  margin: 0;
  padding: 0;
}

.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* ========== 侧边栏 ========== */
.sidebar {
  width: 220px;
  background: #FFFFFF;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #EBEEF5;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.03);
  transition: width 0.25s ease;
  overflow: hidden;
}

.sidebar-collapsed .sidebar {
  width: 64px;
}

.sidebar-collapsed .logo-text-group,
.sidebar-collapsed .menu-label,
.sidebar-collapsed .menu-item span {
  display: none;
}

.sidebar-collapsed .menu-item {
  justify-content: center;
  margin-left: 0;
  padding: 0;
}

.sidebar-collapsed .menu-item.active::before {
  left: 0;
}

.sidebar-collapsed .logo-area {
  justify-content: center;
  padding: 16px 8px;
}

.sidebar-collapsed .collapse-btn {
  display: none;
}

.collapse-btn {
  margin-left: auto;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
  transition: all 0.2s;
  flex-shrink: 0;
}

.collapse-btn:hover {
  background: #F0F2F5;
  color: #50c6c8;
}

.logo-area {
  padding: 16px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.logo-text-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.logo-text {
  color: #1A1A2E;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 2px;
  white-space: nowrap;
}

.logo-sub {
  color: #B0B0B0;
  font-size: 11px;
  letter-spacing: 1px;
  white-space: nowrap;
}

.menu-section {
  flex: 1;
  padding: 16px 0;
  overflow-y: auto;
}

.menu-section::-webkit-scrollbar {
  width: 4px;
}

.menu-section::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius: 2px;
}

.menu-section::-webkit-scrollbar-thumb:hover {
  background: #C0C0C0;
}

.menu-group {
  margin-bottom: 20px;
}

.menu-group:last-child {
  margin-bottom: 0;
}

.menu-label {
  font-size: 13px;
  color: #9CA3AF;
  letter-spacing: 1px;
  padding: 0 20px 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.menu-label::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #50c6c8;
  opacity: 0.55;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 12px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  text-decoration: none;
  color: #5A6070;
  font-size: 14px;
  transition: all 0.2s ease;
  position: relative;
  margin-left: 6px;
}

.menu-item:hover {
  background: #F5F7FA;
  color: #1A1A2E;
}


.menu-item.active {
  background: linear-gradient(90deg, rgba(80, 198, 200, 0.16), rgba(80, 198, 200, 0.05));
  color: #50c6c8;
  font-weight: 600;
}

.menu-item.active::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  border-radius: 2px;
  background: #50c6c8;
}

.menu-icon {
  font-size: 15px;
  width: 18px;
  text-align: center;
  display: inline-block;
  transition: transform 0.2s ease, color 0.2s ease;
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid #F0F2F5;
  text-align: center;
}

.version-text {
  font-size: 11px;
  color: #C0C0C0;
}

/* ========== 右侧区域 ========== */
.right-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
}

/* ========== 顶部导航栏 ========== */
.top-header {
  height: 56px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  z-index: 10;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.sidebar-toggle-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5A6070;
  font-size: 18px;
  transition: all 0.2s;
}
.sidebar-toggle-btn:hover {
  background: #F0F2F5;
  color: #50c6c8;
}

.header-breadcrumb {
  font-size: 16px;
  font-weight: 600;
  color: #2C3E50;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.dark-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
  color: #5A6070;
}

.dark-toggle:hover {
  background: #F0F2F5;
  color: #1A1A2E;
}

.help-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
  color: #5A6070;
}

.help-entry:hover {
  background: #F0F2F5;
  color: #50c6c8;
}

.website-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
  color: #5A6070;
}

.website-entry:hover {
  background: #F0F2F5;
  color: #50c6c8;
}

.header-notify {
  display: flex;
  align-items: center;
}

.notify-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
}

.notify-trigger:hover {
  background: #F0F2F5;
}

.notify-trigger .el-icon-bell {
  font-size: 20px;
  color: #5A6070;
}

.notify-badge>>>.el-badge__content {
  border: 2px solid #FFFFFF;
}

/* ========== 通知面板 ========== */
.notify-panel {
  display: flex;
  flex-direction: column;
}

.notify-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #F0F2F5;
}

.notify-title {
  font-size: 15px;
  font-weight: 600;
  color: #1D1D26;
}

.notify-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.notify-read-all {
  font-size: 13px;
  color: #50c6c8;
  cursor: pointer;
  user-select: none;
}

.notify-read-all:hover {
  color: #3db0b2;
}

.notify-view-all {
  font-size: 13px;
  color: #909399;
  cursor: pointer;
  user-select: none;
}

.notify-view-all:hover {
  color: #50c6c8;
}

.notify-list {
  max-height: 360px;
  overflow-y: auto;
}

.notify-item {
  display: flex;
  gap: 14px;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid #F8F8FA;
}

.notify-item:hover {
  background: #F5F7FA;
}

.notify-item.unread {
  background: rgba(80, 198, 200, 0.04);
}

.notify-item.unread:hover {
  background: rgba(80, 198, 200, 0.08);
}

.notify-item-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
}

.notify-item-icon.icon-submission {
  background: rgba(80, 198, 200, 0.12);
  color: #50c6c8;
}

.notify-item-icon.icon-feedback {
  background: rgba(243, 156, 18, 0.12);
  color: #F39C12;
}

.notify-item-icon.icon-user {
  background: rgba(46, 204, 113, 0.12);
  color: #2ECC71;
}

.notify-item-icon.icon-report {
  background: rgba(231, 76, 60, 0.12);
  color: #E74C3C;
}

.notify-item-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notify-item-title {
  font-size: 14px;
  font-weight: 500;
  color: #2C3E50;
  display: flex;
  align-items: center;
  gap: 6px;
}

.notify-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #E74C3C;
  flex-shrink: 0;
}

.notify-item-content {
  font-size: 13px;
  color: #8E8E93;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notify-item-time {
  font-size: 12px;
  color: #C0C4CC;
}

.notify-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: #C8C8CC;
  gap: 10px;
  font-size: 14px;
}

.notify-empty i {
  font-size: 40px;
}

/* ========== 用户区 ========== */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background 0.2s;
}

.user-info:hover {
  background: #F0F2F5;
}

.user-avatar {
  background: linear-gradient(135deg, #50c6c8, #3db0b2) !important;
}

.user-name {
  font-size: 14px;
  color: #2C3E50;
  font-weight: 500;
}

.user-info .el-icon-arrow-down {
  font-size: 12px;
  color: #B0B0B0;
  transition: transform 0.2s;
}

/* ========== 主内容区 ========== */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* ========== 全局主题色 ========== */
.el-button--primary {
  background-color: #50c6c8 !important;
  border-color: #50c6c8 !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #3db0b2 !important;
  border-color: #3db0b2 !important;
}

.el-button--primary.is-plain {
  color: #50c6c8 !important;
  background: rgba(80, 198, 200, 0.08) !important;
  border-color: rgba(80, 198, 200, 0.4) !important;
}

.el-tag--primary {
  background-color: rgba(80, 198, 200, 0.1) !important;
  border-color: rgba(80, 198, 200, 0.3) !important;
  color: #50c6c8 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #50c6c8 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #50c6c8 !important;
}

.el-tabs__active-bar {
  background-color: #50c6c8 !important;
}

.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #50c6c8 !important;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #50c6c8 !important;
  background-color: #50c6c8 !important;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #50c6c8 !important;
}

.el-switch.is-checked .el-switch__core {
  border-color: #50c6c8 !important;
  background-color: #50c6c8 !important;
}

.el-button--text {
  color: #50c6c8 !important;
}

.el-date-table td.current:not(.disabled) span {
  background-color: #50c6c8 !important;
}

.el-date-table td.today span {
  color: #50c6c8 !important;
}

.el-select-dropdown__item.selected {
  color: #50c6c8 !important;
}

/* ========== 通知弹窗全局 ========== */
.notify-popover {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12) !important;
}

/* ========== 深色模式（灰蓝调） ========== */
.dark-mode {
  background: #141a23;
}

.dark-mode .sidebar {
  background: #1a2232;
  border-right-color: #2a3340;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
}

.dark-mode .logo-area {
  border-bottom-color: #2a3340;
}

.dark-mode .logo-text {
  color: #E0E0E0;
}

.dark-mode .logo-sub {
  color: #888888;
}

.dark-mode .menu-label {
  color: #5a6478;
}

.dark-mode .menu-item {
  color: #9AA3B5;
}

.dark-mode .menu-item:hover {
  background: #212a38;
  color: #E6E8EE;
}

.dark-mode .menu-item.active {
  background: linear-gradient(90deg, rgba(80, 198, 200, 0.22), rgba(80, 198, 200, 0.08));
  color: #50c6c8;
}

.dark-mode .menu-section::-webkit-scrollbar-thumb {
  background: #333c4a;
}

.dark-mode .menu-section::-webkit-scrollbar-thumb:hover {
  background: #46536a;
}

.dark-mode .sidebar-footer {
  border-top-color: #2a3340;
}

.dark-mode .top-header {
  background: #1a2232;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.dark-mode .header-breadcrumb {
  color: #E0E0E0;
}

.dark-mode .dark-toggle {
  color: #999999;
}

.dark-mode .dark-toggle:hover {
  background: #212a38;
  color: #E0E0E0;
}

.dark-mode .sidebar-toggle-btn { color: #999; }
.dark-mode .sidebar-toggle-btn:hover { background: #212a38; color: #50c6c8; }

.dark-mode .user-name {
  color: #E0E0E0;
}

.dark-mode .user-info:hover {
  background: #212a38;
}

.dark-mode .user-info .el-icon-arrow-down {
  color: #888888;
}

/* 深色模式 - Element UI */
.dark-mode .el-input__inner {
  background-color: #212a38 !important;
  border-color: #2a3340 !important;
  color: #E0E0E0 !important;
}

.dark-mode .el-input__inner::placeholder {
  color: #666666 !important;
}

.dark-mode .el-table {
  background-color: #1a2232 !important;
  color: #E0E0E0 !important;
}

.dark-mode .el-table::before {
  background-color: #2a3340 !important;
}

.dark-mode .el-table__header-wrapper,
.dark-mode .el-table__body-wrapper,
.dark-mode .el-table__fixed,
.dark-mode .el-table__fixed-right {
  background-color: #1a2232 !important;
}

.dark-mode .el-table th {
  background-color: #1e2738 !important;
  color: #A0A0A0 !important;
  border-bottom-color: #2a3340 !important;
}

.dark-mode .el-table td {
  background-color: #1a2232 !important;
  border-bottom-color: #2a3340 !important;
  color: #E0E0E0 !important;
}

.dark-mode .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #1c2535 !important;
}

.dark-mode .el-table__body tr:hover>td {
  background-color: #212a38 !important;
}

.dark-mode .el-table__empty-text {
  color: #888888 !important;
}

.dark-mode .el-table__expand-icon {
  color: #999999 !important;
}

.dark-mode .el-dialog {
  background-color: #1a2232 !important;
}

.dark-mode .el-dialog__title {
  color: #E0E0E0 !important;
}

.dark-mode .el-dialog__body {
  color: #B0B0B0 !important;
}

.dark-mode .el-select-dropdown {
  background-color: #1a2232 !important;
  border-color: #2a3340 !important;
}

.dark-mode .el-select-dropdown__item {
  color: #A0A0A0 !important;
}

.dark-mode .el-select-dropdown__item.hover {
  background-color: #212a38 !important;
}

.dark-mode .el-pagination__total,
.dark-mode .el-pagination__jump {
  color: #999999 !important;
}

.dark-mode .el-pager li {
  background-color: #212a38 !important;
  color: #A0A0A0 !important;
}

.dark-mode .el-card {
  background-color: #1a2232 !important;
  border-color: #2a3340 !important;
  color: #E0E0E0 !important;
}

.dark-mode .el-tabs__item {
  color: #888888 !important;
}

.dark-mode .el-form-item__label {
  color: #999999 !important;
}

.dark-mode .el-loading-mask {
  background-color: rgba(26, 34, 50, 0.85) !important;
}

/* 深色模式 - 页面元素 */
.dark-mode .search-bar {
  background: #1a2232 !important;
}

.dark-mode .stat-card {
  background: #1a2232 !important;
}

.dark-mode .stat-card:hover {
  background: #212a38 !important;
}

.dark-mode .chart-card {
  background: #1a2232 !important;
}

.dark-mode .page-title,
.dark-mode h2,
.dark-mode h3 {
  color: #E0E0E0 !important;
}

.dark-mode .page-desc,
.dark-mode .stat-label {
  color: #999999 !important;
}

.dark-mode .card-title {
  color: #E0E0E0 !important;
}

.dark-mode .card-meta {
  color: #888888 !important;
}

.dark-mode .card-actions {
  border-top-color: #2a3340 !important;
}

/* 深色模式 - 通知面板 */
.dark-mode .notify-trigger:hover {
  background: #212a38;
}

.dark-mode .notify-trigger .el-icon-bell {
  color: #999999;
}

.dark-mode .notify-badge>>>.el-badge__content {
  border-color: #1a2232;
}

/* 个人信息弹窗 */
.profile-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.profile-dialog .el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #F0F2F5;
}

.profile-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A2E;
}

.profile-dialog .el-dialog__body {
  padding: 18px 24px 6px;
}

.profile-dialog .el-dialog__footer {
  padding: 12px 24px 22px;
}

.profile-dialog .el-form-item {
  margin-bottom: 16px;
}

.profile-dialog .el-form-item__label {
  font-size: 13px;
  color: #5A6070;
  line-height: 1;
  padding-bottom: 8px;
}

.profile-dialog .el-input__inner {
  border-radius: 6px;
}

.profile-dialog .el-input__prefix {
  color: #B0B0B0;
}

.profile-dialog .el-input.is-focus .el-input__inner {
  border-color: #50c6c8;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(80, 198, 200, 0.12), rgba(80, 198, 200, 0.03));
  border-radius: 12px;
  margin-bottom: 18px;
}

.profile-avatar {
  background: linear-gradient(135deg, #50c6c8, #3db0b2) !important;
  color: #fff;
  font-size: 24px;
  flex-shrink: 0;
}

.profile-hero-info {
  min-width: 0;
}

.profile-hero-name {
  font-size: 17px;
  font-weight: 600;
  color: #1A1A2E;
  display: flex;
  align-items: center;
  gap: 8px;
}

.profile-hero-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.profile-meta {
  margin-top: 4px;
  padding: 12px 14px;
  background: #F7F9FC;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.profile-meta-item i {
  color: #50c6c8;
  font-size: 14px;
}

.profile-meta-label {
  color: #909399;
  flex-shrink: 0;
}

.profile-text {
  color: #5A6070;
  font-size: 13px;
}

/* 深色模式 - 个人信息弹窗 */
.dark-mode .profile-dialog .el-dialog__header {
  border-bottom-color: #2a3340;
}

.dark-mode .profile-dialog .el-dialog__title {
  color: #E0E0E0;
}

.dark-mode .profile-dialog .el-form-item__label {
  color: #999999;
}

.dark-mode .profile-dialog .el-input__prefix {
  color: #666666;
}

.dark-mode .profile-hero {
  background: rgba(80, 198, 200, 0.12);
}

.dark-mode .profile-hero-name {
  color: #E0E0E0;
}

.dark-mode .profile-hero-sub {
  color: #888888;
}

.dark-mode .profile-meta {
  background: #212a38;
}

.dark-mode .profile-meta-label {
  color: #888888;
}

.dark-mode .profile-text {
  color: #B0B0B0;
}

/* 修改密码弹窗 */
.password-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.password-dialog .el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #F0F2F5;
}

.password-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A2E;
}

.password-dialog .el-dialog__body {
  padding: 18px 24px 6px;
}

.password-dialog .el-dialog__footer {
  padding: 12px 24px 22px;
}

.pwd-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #50c6c8;
  background: rgba(80, 198, 200, 0.08);
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 16px;
}

.pwd-tip i {
  font-size: 14px;
}

.password-dialog .el-form-item {
  margin-bottom: 16px;
}

.password-dialog .el-form-item__label {
  font-size: 13px;
  color: #5A6070;
  line-height: 1;
  padding-bottom: 8px;
}

.password-dialog .el-input__inner {
  border-radius: 6px;
}

.password-dialog .el-input__prefix {
  color: #B0B0B0;
}

.password-dialog .el-input.is-focus .el-input__inner {
  border-color: #50c6c8;
}

/* 深色模式 - 修改密码弹窗 */
.dark-mode .password-dialog .el-dialog__header {
  border-bottom-color: #2a3340;
}

.dark-mode .password-dialog .el-dialog__title {
  color: #E0E0E0;
}

.dark-mode .password-dialog .el-form-item__label {
  color: #999999;
}

.dark-mode .password-dialog .el-input__prefix {
  color: #666666;
}

.dark-mode .pwd-tip {
  background: rgba(80, 198, 200, 0.12);
}
</style>
